import React from 'react';
import ReactDOM from 'react-dom/client';

// Bootstrap CSS first
import 'bootstrap/dist/css/bootstrap.min.css';
// Then the JS bundle (Popper + all plugins)
import 'bootstrap/dist/js/bootstrap.bundle.min';

import './index.css';
import './JoinUs.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
